/**
 * Auto IN STOCK Filter
 * Supports both native Shopify filter (filter.v.availability) 
 * dan custom availability checkbox (name="availability")
 */
(function() {
  'use strict';

  console.log('[AutoInStock] Starting...');

  var filterForm = document.querySelector('[data-sidebar-filter-form]');

  // Support kedua jenis availability checkbox
  var inStockCheckbox = document.querySelector('input[name="filter.v.availability"][value="1"]') ||
                        document.querySelector('[data-availability-checkbox="in-stock"]');

  if (!filterForm || !inStockCheckbox) {
    console.error('[AutoInStock] Elements not found - filterForm:', !!filterForm, '| inStockCheckbox:', !!inStockCheckbox);
    return;
  }

  var isNativeFilter = inStockCheckbox.name === 'filter.v.availability';
  console.log('[AutoInStock] Mode:', isNativeFilter ? 'Native Shopify filter' : 'Custom availability checkbox');
  console.log('[AutoInStock] Ready');

  var isUpdating = false;
  var checkTimeout = null;

  function scheduleCheck(delay) {
    if (checkTimeout) clearTimeout(checkTimeout);
    checkTimeout = setTimeout(checkState, delay || 500);
  }

  function countActiveVariantFilters() {
    var count = 0;

    // Hitung native Shopify filter.v.option checkboxes (Size, Gender, Brand, dll)
    var nativeChecked = filterForm.querySelectorAll('input[name*="filter.v.option"]:checked, input[name*="filter.p."]:checked');
    count += nativeChecked.length;

    // Juga hitung filter price jika aktif
    var priceMin = filterForm.querySelector('[data-field-price-min]');
    var priceMax = filterForm.querySelector('[data-field-price-max]');
    if (priceMin && priceMax && (priceMin.value || priceMax.value)) {
      count++;
    }

    console.log('[AutoInStock] Active filters count:', count);
    return count;
  }

  function enableInStock() {
    if (inStockCheckbox.checked) return;
    inStockCheckbox.checked = true;
    inStockCheckbox.dispatchEvent(new Event('change', { bubbles: true }));

    // Jika native filter, trigger form AJAX submission
    if (isNativeFilter) {
      filterForm.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  function disableInStock() {
    if (!inStockCheckbox.checked) return;
    inStockCheckbox.checked = false;
    inStockCheckbox.dispatchEvent(new Event('change', { bubbles: true }));

    // Jika native filter, trigger form AJAX submission
    if (isNativeFilter) {
      filterForm.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  function checkState() {
    if (isUpdating) {
      console.log('[AutoInStock] Skip (updating)');
      return;
    }

    // Re-acquire elements jika DOM di-replace oleh AJAX
    inStockCheckbox = document.querySelector('input[name="filter.v.availability"][value="1"]') ||
                      document.querySelector('[data-availability-checkbox="in-stock"]');
    filterForm = document.querySelector('[data-sidebar-filter-form]');

    if (!inStockCheckbox || !filterForm) {
      console.log('[AutoInStock] Elements lost after DOM update');
      return;
    }

    var activeCount = countActiveVariantFilters();
    var isChecked = inStockCheckbox.checked;

    console.log('[AutoInStock] Active filters:', activeCount, '| InStock checked:', isChecked);

    if (activeCount > 0 && !isChecked) {
      isUpdating = true;
      console.log('[AutoInStock] AUTO ENABLE In Stock');
      enableInStock();
      setTimeout(function() { isUpdating = false; }, 1000);

    } else if (activeCount === 0 && isChecked) {
      isUpdating = true;
      console.log('[AutoInStock] AUTO DISABLE In Stock');
      disableInStock();
      setTimeout(function() { isUpdating = false; }, 1000);

    } else {
      console.log('[AutoInStock] State OK');
    }
  }

  // Listen semua perubahan checkbox di filter form
  filterForm.addEventListener('change', function(e) {
    if (isUpdating) return;
    var name = e.target.name || '';
    // Hanya trigger untuk filter bukan availability
    if (name !== 'availability' && !name.includes('filter.v.availability')) {
      console.log('[AutoInStock] Filter changed:', name);
      scheduleCheck(400);
    }
  });

  // Observe active pills container untuk handle clear all
  var pillsContainer = document.querySelector('[data-active-filters]');
  if (pillsContainer) {
    new MutationObserver(function() {
      if (!isUpdating) scheduleCheck(600);
    }).observe(pillsContainer, { childList: true, subtree: true });
  }

  // Observe products grid untuk handle setelah AJAX reload
  var productsGrid = document.querySelector('[data-products-grid]');
  if (productsGrid) {
    new MutationObserver(function() {
      if (!isUpdating) scheduleCheck(800);
    }).observe(productsGrid, { childList: true, subtree: false });
  }

  // Initial check
  scheduleCheck(1000);
  console.log('[AutoInStock] Initialized');
})();